import { toggleDropdown } from "~/utils/menu";
import { useRef } from "react";

export default function MobileMenuDropdown() {
    const elRef = useRef<HTMLElement | null>(null);
    const toggleDD = (e: React.MouseEvent<HTMLElement>) => toggleDropdown(e, elRef as React.RefObject<HTMLElement>)
    
    return(
        <i onClick={toggleDD} ref={elRef} className="bi bi-chevron-down toggle-dropdown"></i>
    )
}